/* eslint-disable*/
import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from "axios";
import { Store } from "redux"; // Ensure you have redux types installed
import ENVConfig from "../../config/config";
import { setUserLoggedOut } from "../../store/features/userSlice";


import { clearInteraction } from "../../store/features/interactionSlice";
import { clearCriteria } from "../../store/features/productCriteriaSlice";
import { resetAlreadySelectedProductState } from '../../store/features/alreadySelectedProductSlice';
import { resetConsensusData } from '../../store/features/consensusSlice';
import { clearProcurementState } from '../../store/features/procurementSlice';
import { resetForecastData } from '../../store/features/forecastSlice';

// Define the type for the Redux store
let store;

// Function to inject the store
export const injectStore = (_store) => {
  store = _store;
};

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: ENVConfig.baseURL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.user?.token;
    const EmailId = state.user?.EmailId; // Assuming userId is stored in the Redux state
    if (token && EmailId) {
      config.headers["Authorization"] = `Bearer ${token}`; // Add token to the Authorization header
      // config.headers["X-User-Id"] = userId; // Add user ID to custom header
    }

    // Detect if payload is FormData
    if (
      config.data instanceof FormData &&
      !(config.headers && config.headers["Content-Type"])
    ) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else if (
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if ((error.response && error.response.status === 401) || error.status === 401) {
          store.dispatch(clearCriteria());
          store.dispatch(resetAlreadySelectedProductState());
          store.dispatch(resetConsensusData());
          store.dispatch(clearInteraction());
          store.dispatch(clearProcurementState());
          store.dispatch(resetForecastData());
          store.dispatch(setUserLoggedOut());
          window.location.reload();
      return Promise.reject(error.response);
    } else {
      return Promise.reject(error.response);
    }
  }
);

export default axiosInstance;
